<div *ngIf="events" class="grid-x margin-b-s">

  <div class="cell shrink"
       style="display: flex; flex-direction: column; align-items: center">
    <span class="mois-event margin-b-xs">{{month}}</span>
    <span class="date-event">{{day}}
      <sup *ngIf="day === '1'">{{'news.event.ordinal.first' | translate}}</sup>
    </span>
  </div>

  <!--Basic events item-->
  <ng-container *ngIf="events.length > 0">
    <div class="cell auto">

      <div *ngFor="let event of events"
           class="bg-white border-event margin-b-s {{getClassByTheme(event)}}"
           style="border-radius: 5px 0 0 5px">

        <div class="paragraphe-event bg-transparent bg-hover">

          <div class="grid-x">

            <div class="cell auto">
              <div (click)="gotToProgram(event)"
                   class="cursor-hover padding-t-xs padding-r-xs">
                <i *ngIf="event.focus"
                   class="fa fa-star margin-r-s"
                   style="font-size: 1.2rem; color: #ecc104"></i>
                <span class="i-block margin-b-xs f-7 font-bold c-black">{{event.title}}</span><br/>
                <div class="line-clamp">{{event.description}}</div>
              </div>
            </div>

            <div class="cell shrink">
              <div style="display: flex; flex-direction: column; justify-content: space-between; align-items: flex-end">
                <div class="margin-b-s">
                  <span class="hds-chip condensed small get chips {{getColorByTheme(event)}}"
                        style="font-weight:500; font-size:11px; width: fit-content;">
                    <ng-container *ngIf="event.theme; else theme">
                      {{'widget.latest-events.theme.'.concat(event.theme) | translate}}
                    </ng-container>
                    <ng-template #theme>
                      {{event.category}}
                    </ng-template>
                  </span>
                </div>
                <!--Event links-->
                <a *ngIf="hasLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
                   [href]="getLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)" (click)="onRedirectToEvent(event, true)"
                   class="hds-chip condensed light-gray border-radius-default small hollow-subscription"
                   style="width: fit-content">
                  <span class="hollow-subscription-text"
                        style="display: flex; align-items: center; font-weight: 500">
                    <i class="fal fa-calendar-check margin-r-xs"
                       style="font-size: 1.2rem"></i>
                    {{'news.event.subscribe-event' | translate}}
                  </span>
                </a>
                <a *ngIf="hasLinkByType(event, linkTypeEnum.COMMERCIAL_LINK) && !hasLinkByType(event, linkTypeEnum.SUBSCRIPTION_LINK)"
                   [href]="getLinkByType(event, linkTypeEnum.COMMERCIAL_LINK)" (click)="onRedirectToEvent(event, false)"
                   class=" hds-chip condensed light-gray border-radius-default small hollow-subscription"
                   style="width: fit-content">
                  <span class="hollow-subscription-text"
                        style="display: flex; align-items: center; font-weight: 500">
                    <i class="fal fa-calendar-check margin-r-xs"
                       style="font-size: 1.2rem"></i>
                    {{'news.event.offer-event' | translate}}
                  </span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div>

  </ng-container>

</div>
